var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.pacote ? _c('div', {
    staticClass: "card border-0 shadow-sm",
    staticStyle: {
      "min-width": "0",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "card-body p-4 d-flex flex-column",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "1",
      "flex-shrink": "0"
    }
  }, [_vm._v("🚀")]), _c('div', {
    staticStyle: {
      "min-width": "0"
    }
  }, [_c('p', {
    staticClass: "font-weight-bolder text-dark mb-0 font-size-sm",
    staticStyle: {
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(" Novidades do Sistema Nuts ")]), _vm.pacote.versao ? _c('span', {
    staticClass: "text-muted",
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v(" Versão " + _vm._s(_vm.pacote.versao) + " ")]) : _vm._e()])]), _c('p', {
    staticClass: "font-weight-bold text-dark-75 mb-0 font-size-sm",
    staticStyle: {
      "white-space": "nowrap",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(" " + _vm._s(_vm.pacote.titulo) + " ")]), _vm.pacote.descricao_curta ? _c('p', {
    staticClass: "text-muted mb-0",
    staticStyle: {
      "font-size": "11px",
      "overflow": "hidden",
      "display": "-webkit-box",
      "-webkit-line-clamp": "2",
      "-webkit-box-orient": "vertical"
    }
  }, [_vm._v(" " + _vm._s(_vm.pacote.descricao_curta) + " ")]) : _vm._e(), _c('div', [_c('span', {
    staticClass: "label label-inline label-light-primary font-weight-bold",
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v(" " + _vm._s(_vm.totalItens) + " " + _vm._s(_vm.totalItens === 1 ? "novidade disponível" : "novidades disponíveis") + " ")])]), _c('button', {
    staticClass: "btn btn-primary btn-sm btn-block font-weight-bolder",
    staticStyle: {
      "font-size": "11px"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('ver-novidades', _vm.pacote);
      }
    }
  }, [_vm._v(" Ver novidades ")])])]) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };